















































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import { ProductLabelColor, ProductLabelOutline } from '~/types/common';

export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    color: {
      type: String as PropType<ProductLabelColor>,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    outline: {
      type: String as PropType<ProductLabelOutline>,
      default: null,
    },
    size: {
      type: Number,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
});
